<template>
  <div class="col-md-5 borderRight">
    <div class="ml15">
      <h3>Каталог</h3>
      <div v-if="selectedAction && Object.keys(selectedAction).length === 0">
        <button
          type="button"
          class="btn btn-success myBtnStyle fz10 cursor"
          @click="updateStoreModal(true)"
        >
          Добавить категорию
        </button>
        <button
          type="button"
          class="btn btn-warning myBtnStyle fz10 cursor ml-1"
          @click="getCategory()"
        >
          Изменить
        </button>
        <button
          type="button"
          class="btn btn-danger myBtnStyle fz10 cursor ml-1"
          @click="deleteCategory()"
        >
          Удалить
        </button>
        <button
          type="button"
          class="btn btn-info myBtnStyle fz10 cursor ml-1"
          v-b-toggle="'findCategoryBlock'"
        >
          Поиск
        </button>
      </div>
      <div v-else>
        <button
          type="button"
          class="btn btn-danger myBtnStyle fz10 cursor ml-1"
          @click="updateCategoryWatchModal({ visible: true })"
        >
          показать действие
        </button>
      </div>
      <Recursive
        :node="treeData"
        @onClick="categoryClick"
        @actionData="actionDataHandler"
      ></Recursive>
    </div>

    <CategoryStoreModal
      :showCategoryModal="showCategoryModal"
      :category="category"
      @update="updateStoreModal"
    ></CategoryStoreModal>

    <CategoryEditModal
      :languages="languages"
      :categorySearchData="categorySearchData"
      :categorySearch="categorySearch"
      :categoryEdit="categoryEdit"
      :showCategoryEditModal="showCategoryEditModal"
      @update="updateEditModal"
    ></CategoryEditModal>

    <CategoryWatch
      :category="actionCategory"
      :showCategoryModal="showCategoryWatchModal"
      :languages="languages"
      @update="updateCategoryWatchModal"
    ></CategoryWatch>
  </div>
</template>

<script>
import { DELETE, GET, POST } from "@/shared/api";
import Recursive from "@/views/allLogic/modals/category/Recursive";
import CategoryEditModal from "@/views/allLogic/modals/category/categoryEdit";
import CategoryStoreModal from "@/views/allLogic/modals/category/categoryStore";
import CategoryWatch from "@/views/allLogic/modals/category/watch";

export default {
  components: {
    Recursive,
    CategoryEditModal,
    CategoryStoreModal,
    CategoryWatch,
  },
  props: {
    languages: [],
  },
  data() {
    return {
      parentCategory: {}, // created for delete category without reload page
      categorySearch: null,
      categorySearchData: [],
      categoryEdit: {},
      showCategoryModal: false,
      showCategoryEditModal: false,
      category: { code: null, ru_title: "" },
      categories: [],
      treeData: {
        code: null,
        title: "Каталог",
        root: true,
        children: [],
      },
      actionCategory: {},
      selectedAction: {},
      showCategoryWatchModal: false,
    };
  },
  methods: {
    actionDataHandler(action) {
      this.selectedAction = action;
    },
    updateCategoryWatchModal(state) {
      if (typeof state === "object" && typeof state.visible === "boolean") {
        this.showCategoryWatchModal = state.visible;
        if (this.showCategoryWatchModal === true) {
          switch (this.selectedAction.secondShortRoute) {
            case "destroy":
              this.getCategory(this.selectedAction.request_data.id);
              break;
            default:
              this.actionCategory = this.selectedAction.request_data.request;
              if (this.actionCategory.translations) {
                this.actionCategory.translations.forEach((el) => {
                  if (el.locale && el.locale === "ru") {
                    el.title = this.actionCategory.title;
                  }
                });
              }
          }
        }
      }
    },

    updateCol(event, state) {
      this.$emit(event, state);
    },
    updateEditModal(state) {
      if (typeof state === "boolean") {
        if (state) {
          this.showCategoryEditModal = true;
        } else {
          this.categorySearch = "";
          this.showCategoryEditModal = false;
        }
      } else {
        if (typeof state === "object" && state.state === "success") {
          this.categoryProducts = [];
          this.clearProduct();
          this.getCategoryProducts();
        }
      }
    },
    updateStoreModal(state = false) {
      if (typeof state === "boolean") {
        if (state) {
          this.showCategoryModal = true;
        } else {
          this.category = { code: null, ru_title: "" };
          this.showCategoryModal = false;
        }
      } else if (typeof state === "object") {
        if (state.created) {
          this.category = { code: null, ru_title: "" };
          this.showCategoryModal = false;
          if (this.currentChoosenNode != null) {
            this.currentChoosenNode.hasChildren = true;
            if (!("children" in this.currentChoosenNode)) {
              this.currentChoosenNode.children = [];
            }
            // this.currentChoosenNode.children.push(response)
          } else {
            // this.treeData.children.push(response)
          }
        }
      }
    },
    getCategory(parent_id = null, editModal = true) {
      if (parent_id === null) {
        parent_id = this.category.parent_id;
      }
      GET([], "/category/" + parent_id, this, false).then((response) => {
        if (editModal) {
          this.categoryEdit = response;
          this.updateEditModal(true);
        } else {
          this.field = response;
        }
      });
    },
    deleteCategory() {
      DELETE(this.category.parent_id, "/category/", this)
        .then((response) => {
          for (let i = 0; i < this.parentCategory.children.length; i++) {
            if (
              this.parentCategory.children[i]["id"] === this.category.parent_id
            ) {
              this.parentCategory.children.splice(i, 1);
            }
          }
        })
        .catch((e) => {});
    },
    categoryClick(node) {
      if (typeof node.selected_action === "object") {
        this.selectedAction = node.selected_action;
      } else {
        this.selectedAction = {};
      }
      this.categoryProducts = [];
      this.productFields = [];
      this.currentChoosenNode = node;
      this.category.parent_id = node.id;
      this.selectedCategory = node.id;

      if (this.selectedCategory !== null) {
        if (node.children && node.children.length === 0) {
          this.getChildrens(node);
        }
        this.updateCol("update", {
          action: "products",
          mode: "get",
          selectedCategory: this.selectedCategory,
          category: this.category,
          currentChoosenNode: this.currentChoosenNode,
        });
      }
    },
    getCategories() {
      GET([], "/category/query/0?mode=main", this, false).then((response) => {
        this.categories = response;
        this.treeData.children = this.unflatten(response);
      });
    },
    unflatten(arr) {
      var tree = [],
        mappedArr = [],
        arrElem,
        mappedElem;

      // First map the nodes of the array to an object -> create a hash table.
      for (var i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.id] = arrElem;
      }

      mappedArr.sort(function (a, b) {
        if (a.code < b.code) {
          return -1;
        }
        if (a.code > b.code) {
          return 1;
        }
        return 0;
      });

      for (var id in mappedArr) {
        if (mappedArr.hasOwnProperty(id)) {
          mappedElem = mappedArr[id];
          // If the element is not at the root level, add it to its parent array of children.
          if (mappedElem.parent_id) {
            mappedArr[mappedElem["parent_id"]]["children"].push(mappedElem);
          }
          // If the element is at the root level, add it to first level elements array.
          else {
            tree.push(mappedElem);
          }
        }
      }
      return tree;
    },
    getChildrens(node) {
      GET(
        [],
        "/category/query/" + node.id + "?mode=children",
        this,
        false
      ).then((response) => {
        if (response.length > 0) {
          this.parentCategory = node;
        }
        for (let index = 0; index < response.length; index++) {
          node.children.push(response[index]);
        }
      });
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>

<style scoped></style>
